/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getAuditingLogs(state) {
		return state.AuditingLogs;
	},
	getAuditingLogTotal(state) {
		return state.AuditingLogTotal;
	}
};
